import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';
import FixBody from '../utils/FixBody';

export default class PdpImagesComponent extends Component {

  get COMPONENTNAME() {
    return 'PdpImagesComponent';
  }

  get SELECTORS() {
    return {
      zoomTrigger: '[data-zoom-trigger]',
      zoomContainer: '[data-zoom-container]',
      zoomImage: '[data-zoom-image-selected]',
      zoomClose: '[data-trigger-close]',
      navigationTrigger: '[data-navigation-trigger]',
      productCarousel: '[data-js-product-carousel]',
      zoomNavigation: '[data-zoom-navigation]',
      zoomPrevArrow: '[data-prev-arrow]',
      zoomNextArrow: '[data-next-arrow]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.isSlickLoaded = false;
  }

  readDOM() {
    return {
      zoomTriggers: this.$component.querySelectorAll(this.SELECTORS.zoomTrigger),
      zoomContainer: this.$component.querySelector(this.SELECTORS.zoomContainer),
      zoomImage: this.$component.querySelector(this.SELECTORS.zoomImage),
      zoomClose: this.$component.querySelector(this.SELECTORS.zoomClose),
      navigationTriggers: this.$component.querySelectorAll(this.SELECTORS.navigationTrigger),
      productCarousel: this.$component.querySelector(this.SELECTORS.productCarousel),
      zoomNavigation: this.$component.querySelector(this.SELECTORS.zoomNavigation),
      zoomPrevArrow: this.$component.querySelector(this.SELECTORS.zoomPrevArrow),
      zoomNextArrow: this.$component.querySelector(this.SELECTORS.zoomNextArrow),
      activePicture: null,
    };
  }

  // MOBILE CAROUSEL //
  importSlick() {
    return new Promise((resolve, reject) => {
      this.moduleLoader.loadCarouselAndExecute(
        module => {
          this.isSlickLoaded = true;
          resolve(module);
        },
        error => {
          console.error("failed to load slick ", error.stack);
          reject(error);
        }
      );
    });
  }

  initSimpleBar(SimpleBar) {
    this.simpleBar = new SimpleBar(this.dom.productCarousel, {
      autoHide: false,
    });
  }

  // open image zoom //
  openZoom(image) {
    FixBody.block();
    this.dom.zoomContainer.classList.remove("--hidden");
    this.dom.zoomImage.style.backgroundImage = `url(${image.dataset.zoomImage})`;
    const activePicture = this.$component.querySelector('[data-navigation-index="' + image.dataset.index + '"]');
    if(activePicture) {
      const image = activePicture.querySelectorAll('img')[0]

      image.classList.add("--active");
      this.dom.activePicture = image;
    }
  }

  async openZoomMobile(imageIndex) {
    if (!this.isSlickLoaded) {
      try {
        await this.importSlick();
      } catch (error) {
        console.error("Cannot open zoom mobile: Slick failed to load", error);
        return;
      }
    }

    FixBody.block();
    this.dom.zoomContainer.classList.remove("--hidden");

    const options = {
      mobileFirst: true,
      prevArrow: this.dom.zoomPrevArrow,
      nextArrow: this.dom.zoomNextArrow,
      initialSlide: parseInt(imageIndex, 10) || 0,
      swipe: true,
      touchMove: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    };

    $(this.dom.zoomNavigation).slick(options);

    $(this.dom.zoomNavigation).on('init', () => {
      this.enablePinchDetection();
    });

    if ($(this.dom.zoomNavigation).hasClass('slick-initialized')) {
      this.enablePinchDetection();
    }
  }

  clickOnNavigationCard(image) {
    this.dom.activePicture ? this.dom.activePicture.classList.remove("--active") : '';
    this.dom.zoomImage.style.backgroundImage = `url(${image.dataset.zoomImage})`;
    const activePicture = image.querySelectorAll('img')[0];
    activePicture.classList.add("--active");
    this.dom.activePicture = activePicture;
  }

  handleMouseMove() {
    if (!this.dom.zoomImage) return;

    this.dom.zoomImage.onmousemove = ({ clientY }) => {
      if (typeof clientY !== 'number') {
        console.warn('image-zoom mouse event failed');
        return 0;
      }
      const perc = (clientY / window.innerHeight) * 100;
      const mousePositionPerc = Math.min(Math.max(perc, 0), 100);
      this.dom.zoomImage.style.backgroundPositionY = mousePositionPerc + "%";
    };
  }

  bindEvents() {
    // handle mouse move on desktop
    if(this.dom.zoomImage && window.matchMedia('(min-width: 768px)').matches) {
      this.handleMouseMove();
    }
    if(this.dom.zoomTriggers) {
      this.dom.zoomTriggers.forEach(image => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          // desktop behaviour
          image.addEventListener("click", this.openZoom.bind(this, image));
        } else {
          //mobile behaviour
          image.addEventListener("click", () => this.openZoomMobile(image.dataset.index));
        }
      });
    }
    if(this.dom.navigationTriggers && window.matchMedia('(min-width: 768px)').matches) {
      this.dom.navigationTriggers.forEach(image => {
        image.addEventListener("click", this.clickOnNavigationCard.bind(this, image));
      });
    }
    if(this.dom.zoomClose) {
      this.dom.zoomClose.addEventListener("click", (event) => {
        FixBody.unblock();
        this.dom.zoomContainer.classList.add("--hidden");
        this.dom.activePicture ? this.dom.activePicture.classList.remove("--active") : '';
        this.dom.activePicture = null;
        if(window.matchMedia('(max-width: 768px)').matches) {
          $(this.dom.zoomNavigation).slick('unslick');
        }
      });
    }
  }

  enablePinchDetection() {
    const element = this.dom.zoomNavigation;

    if (!element) return;

    let isPinching = false;

    element.addEventListener('touchstart', e => {
      if (e.touches.length > 1) {
        isPinching = true;
        $(element).slick('slickSetOption', 'swipe', false, false);
      }
    });

    element.addEventListener('touchend', e => {
      if (isPinching) {
        isPinching = false;
        $(element).slick('slickSetOption', 'swipe', true, false);
      }
    });
  }

  async render() {
    super.render();
    this.dom = this.readDOM();

    // Load Slick asynchronously on component initialization
    this.importSlick().catch(error => {
      console.error("Failed to preload Slick carousel", error);
    });

    if (isMobile(MobileBreakpoint.Max767)) {
      this.moduleLoader.loadSimpleBarAndExecute(
        module => {
          this.initSimpleBar(module.default);
        },
        error => {
          console.error('failed to load SimpleBar ', error.stack);
        }
      );
    }
    this.bindEvents();
  }
}
